import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["children", "image", "className", "size", "imageProps", "scale"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { forwardRef } from 'react';
import { cnBem } from '@carnica/utils';
import { QR } from '@carnica/fork-react-qr-rounded';
import { withDataConverter } from '@beef/react';
import { Text } from "../Text";
import styles from "./styles.pcss";
import { dataConverter, getLogoSize } from "./utils";
var cnQRCode = cnBem('qrcode', styles);
var renderContent = function renderContent(params) {
  var Image = params.image,
    imageProps = params.imageProps,
    children = params.children,
    size = params.size,
    scale = params.scale;
  if (typeof Image === 'string') {
    var props = imageProps || {};
    return /*#__PURE__*/React.createElement("img", _extends({}, props, {
      alt: props.alt || 'изображение для QR-кода',
      className: cnQRCode('image', [props === null || props === void 0 ? void 0 : props.className]),
      src: Image,
      style: _objectSpread(_objectSpread({}, props.style), {}, _defineProperty({}, '--qr-image-size', "".concat(getLogoSize(size) * scale, "px"))),
      "data-t-id": "components-QRCode"
    }));
  }
  if (Image) {
    return /*#__PURE__*/React.createElement(Image, _extends({}, imageProps || {}, {
      className: cnQRCode('icon', [imageProps === null || imageProps === void 0 ? void 0 : imageProps.className]),
      size: getLogoSize(size) * scale
    }));
  }
  return /*#__PURE__*/React.createElement(Text, {
    align: "center",
    lineHeight: "1em",
    size: 20 * scale
  }, children);
};
var QRCodeRender = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    image = _ref.image,
    className = _ref.className,
    size = _ref.size,
    imageProps = _ref.imageProps,
    scale = _ref.scale,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(QR, _extends({
    className: cnQRCode(null, [className]),
    cutoutElement: /*#__PURE__*/React.createElement("div", {
      className: cnQRCode('container')
    }, renderContent({
      image: image,
      imageProps: imageProps,
      children: children,
      size: size,
      scale: scale
    })),
    ref: ref
  }, otherProps));
});
export var QRCode = withDataConverter(dataConverter)(QRCodeRender);